import React from "react";
import ModalInfo from "../../ModalInfo";

class Page3 extends React.Component {
  state = {
    visible: true,
    question1Answer: null,
    question2Answer: null,
    modalShow: true,
    instructions: (
      <div>
        <p>
          Well done on completing this activity. It may be helpful to think
          about why you’ve changed your mind, consider the questions below.
        </p>
      </div>
    ),
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 3) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  saveAnswer1Change = (event) => {
    this.setState({ question1Answer: event.target.value });
    this.props.updatePdf1(event.target.value);
  };

  saveAnswer2Change = (event) => {
    this.setState({ question2Answer: event.target.value });
    this.props.updatePdf2(event.target.value);
  };
  render() {
    let modalClose = () => this.setState({ modalShow: false });

    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0 d-md-block">Reflective Questions</h3>
                </li>
                <li className="nav-item"></li>
              </ul>
              <ul className="nav navbar-nav ml-auto">
                <div>
                  <i
                    className="fas fa-info-square fa-3x"
                    onClick={() => this.setState({ modalShow: true })}
                  ></i>
                </div>
              </ul>
            </nav>

            <br />
            <br />
            <div className="container-fluid row d-flex justify-content-center">
              <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
                <div className="card mb-4 box-shadow h-100 " id="pageContent_2">
                  <ul className="list-group list-group-flush text-dark ">
                    <li className="list-group-item form-card-1">
                      <div className="d-flex">
                        <div className="p-2" id="moduleContentText">
                          Reflect on your top five values, what do they tell you
                          about why you changed your mind?
                        </div>
                      </div>
                    </li>

                    <li className="list-group-item form-card-2">
                      <div className="d-flex flex-column bd-highlight mb-3 ">
                        <div className="form-group">
                          <textarea
                            className="form-control "
                            id="exampleFormControlTextarea1"
                            placeholder="Enter your answer here..."
                            rows="10"
                            value={this.state.question1Answer}
                            onChange={this.saveAnswer1Change}
                          ></textarea>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <br />
            <br />
            <div className="container-fluid row d-flex justify-content-center">
              <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
                <div className="card mb-4 box-shadow h-100 " id="pageContent_2">
                  <ul className="list-group list-group-flush text-dark ">
                    <li className="list-group-item form-card-1">
                      <div className="d-flex ">
                        <div className="p-2" id="moduleContentText">
                          Values are usually fairly stable, yet they don't have
                          strict limits or boundaries. As you move through life,
                          your values may change. For example, when you start
                          your career, success – measured by money and status –
                          might be a top priority. But after you have a family,
                          work-life balance may be what you value more. As your
                          definition of success changes, so do your personal
                          values.
                          <br />
                          <br />
                          What does success look like to you?
                        </div>
                      </div>
                    </li>

                    <li className="list-group-item form-card-2">
                      <div className="d-flex flex-column bd-highlight mb-3 ">
                        <div className="form-group">
                          <textarea
                            className="form-control "
                            id="exampleFormControlTextarea1"
                            placeholder="Enter your answer here..."
                            rows="10"
                            value={this.state.question2Answer}
                            onChange={this.saveAnswer2Change}
                          ></textarea>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <br />
            <br />
            <ModalInfo
              show={this.state.modalShow}
              onHide={modalClose}
              title="INSTRUCTIONS"
              content={this.state.instructions}
            />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page3;
